<template>
  <div id="app">
    <home/>
  </div>
</template>

<script>
import Home from "@/h5/Home";
import "@/css/style.css";
import "@/css/home.css";

export default {
  name: 'App',
  components: {
    Home
  }
}
</script>

<style>
#app {
  text-align: center;
  color: #2c3e50;
  width: 100%;
  height: 100%;
  overflow: hidden;
}
</style>
